import { useState } from "react";
import "./newTest.style.scss";
import QuestionComponent from "./question.component";
import Button from "@material-ui/core/Button";
import PreviousIcon from "@material-ui/icons/ArrowRightRounded";
import NextIcon from "@material-ui/icons/ArrowLeftRounded";
import JsonData from "../../assets/question.json";
import { Dialog, DialogTitle, DialogActions, DialogContent, TextField, Typography } from "@material-ui/core";
import HttpModule from '../../services/http.module';

const Data = {};
const dialogClassNames = "col-12 py-1 text-center";

export function NewTest(props) {
  const [questionIndex, setQuestionIndex] = useState(0);
  const [isSelected, setSelected] = useState(false);
  const [showDialog, setShowDialog] = useState(true);
  const [userData, setUserData] = useState({
    UserName: "",
    PhoneNumber: "",
    KidAge: "",
    EducationLevel: "",
    IdCode: "",
    // Answers: "",
    // KidSex: "",
  });
  const [error, onError] = useState('');
  const [kidSex, setKidSex] = useState(0)
  const OnSelect = ({ value, id }) => {
    Data[id] = value;
    setSelected(true);
  };

  const setData = (name) => (v) => {
    const current = userData;
    current[name] = v.target.value;
    setUserData(current)
  }

  const SetKidSex = (v) => (e) => {
    setKidSex(v);
  }

  const Submit = () => {
    const payload = {
      KidSex: kidSex,
      ...userData,
      Answers: Data
    }

    HttpModule.SubmitNewTest(payload).then(r => {
      alert("ممنون از مشارکت شما");
      props.history.push("/");
    }).catch(() => {
      alert("خطا در ثبت اطلاعات لطفا دوباره تلاش کنید");
    });
  };

  const OnClose = () => {
    for (const v of Object.values(userData)) {
      if (!v) {
        onError("لطفا تمامی فیلد ها را پر کنید")
        return false;
      }
    }

    if (kidSex === 0) onError("لطفا جنسیت کودک خود را مشخص کنید")
    else setShowDialog(false);
  }

  return (
    <div className="row p-5">
      <div className="col-12">
        <div className="row">
          <Dialog open={showDialog} onClose={OnClose} fullWidth>
            <DialogTitle>
              اطلاعات تکمیلی
            </DialogTitle>
            <DialogContent>
              <div className="row">
                <div className={dialogClassNames}>
                  <TextField
                    className="w-75"
                    variant="outlined"
                    label="نام و نام خانوادگی"
                    onChange={setData("UserName")}
                  />
                </div>
              </div>
              <div className="row">
                <div className={dialogClassNames}>
                  <TextField
                    className="w-75"
                    variant="outlined"
                    label="شماره تماس"
                    type='number'
                    onChange={setData("PhoneNumber")}
                  />
                </div>
              </div>
              <div className="row">
                <div className={dialogClassNames}>
                  <TextField
                    className="w-75"
                    variant="outlined"
                    label="کد ملی کودک"
                    onChange={setData("IdCode")}
                  />
                </div>
              </div>
              <div className="row">
                <div className={dialogClassNames}>
                  <TextField
                    className="w-75"
                    variant="outlined"
                    label="سن فرزند"
                    onChange={setData("KidAge")}
                  />
                </div>
              </div>
              <div className="row">
                <div className={dialogClassNames}>
                  <TextField
                    className="w-75"
                    variant="outlined"
                    label="پایه تحصیلی فرزند"
                    onChange={setData("EducationLevel")}
                  />
                </div>
              </div>
              <div className="row">
                <div className={dialogClassNames}>
                  جنسیت فرزند :
                  <br />
                  <Button
                    variant={kidSex === 2 ? "contained" : "outlined"}
                    onClick={SetKidSex(2)}
                    color="primary"
                    className="p-2 mx-3 rounded"
                  >دختر</Button>
                  <Button
                    variant={kidSex === 1 ? "contained" : "outlined"}
                    onClick={SetKidSex(1)}
                    color="primary"
                    className="p-2 mx-3 rounded"
                  > پسر</Button>
                </div>
              </div>
              <div className="row">
                <div className={dialogClassNames}>
                  <Typography className='text-danger' >

                    {error}
                  </Typography>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={OnClose} variant="outlined" color="primary" >
                ثبت و ادامه
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div className="row">
          <div className="col-12">
            {JsonData[questionIndex] && (
              <QuestionComponent
                index={questionIndex}
                onSelect={OnSelect}
                userChoice={Data[questionIndex + 1] || 0}
                title={JsonData[questionIndex]}
              />
            )}
          </div>
        </div>
        <div className="row pt-5">
          <div className="col-6 text-center">
            <Button
              disabled={questionIndex === 0}
              onClick={() => {
                if (questionIndex === 0) return;
                setQuestionIndex(questionIndex - 1);
                setSelected(!Data[questionIndex + 1] ? true : false)
              }}
            >
              <PreviousIcon />
              قبلی
            </Button>
          </div>
          <div className="col-6 text-center">
            {questionIndex === JsonData.length - 1 ?
              <Button
                disabled={!isSelected}
                onClick={Submit}
              >
                ثبت
                <NextIcon />
              </Button>
              :
              <Button
                disabled={questionIndex === JsonData.length - 1 || !isSelected}
                onClick={() => {
                  if (questionIndex === JsonData.length - 1) return;
                  setQuestionIndex(questionIndex + 1);
                  setSelected(false);
                }}
              >
                بعدی
                <NextIcon />
              </Button>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center py-5">
            {questionIndex + 1} از {JsonData.length}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewTest;
